import arabicUiCopy from "../statics/arabicUiCopy";
import localization from "../statics/localization";
export const flowCopy = () => localization.getLanguage() === "arb" ? arabicUiCopy.flow : localization.getLanguage() === "tr" ? {
  error: "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
  loadError: "Bilgiler yüklenemedi. Lütfen tekrar deneyin.",
  retry: "Tekrar dene", loading: "Yükleniyor…",
  buffering: "Yayın yükleniyor…", reconnecting: "Yayına yeniden bağlanılıyor…",
  streamStopped: "Yayın ilerlemiyor. Lütfen tekrar deneyin.",
  paymentError: "Ödeme sonucu doğrulanamadı. Yeniden ödeme yapmadan önce satın alma geçmişinizi kontrol edin.",
  unavailable: "Bu işlem şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin."
} : {
  error: "The action could not be completed. Please try again.",
  loadError: "Could not load the information. Please try again.",
  retry: "Try again", loading: "Loading…",
  buffering: "Buffering…", reconnecting: "Reconnecting to the stream…",
  streamStopped: "The stream has stopped. Please try again.",
  paymentError: "Payment could not be confirmed. Check your purchase history before paying again.",
  unavailable: "This action is currently unavailable. Please try again later."
};
